import { createContext } from 'react';
import Identity from './types/Identity';

// TODO: Need to support overriding all of the default language, timezone, etc.
const IdentityContext = createContext<Identity | null>(null);

export default IdentityContext;
